<template>
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageaddheader :title="title" :title1="title1" :items="items" />

        <div class="card">
          <div class="card-body">
            <div class="table-top">
              <div class="search-set">
                <div class="search-input">
                  <a class="btn btn-searchset">
                    <img src="../../../assets/img/icons/search-white.svg" alt="img" />
                  </a>
                  <div class="dataTables_filter">
                    <label>
                      <input
                        v-model.trim="filters.search"
                        type="search"
                        class="form-control form-control-sm"
                        placeholder="Search quotation, customer, mobile..."
                        @input="fetchQuotations"
                      />
                    </label>
                  </div>
                </div>
              </div>
              <div class="quotation-filters">
                <select v-model="filters.status" class="form-control" @change="fetchQuotations">
                  <option value="">All Status</option>
                  <option v-for="status in statuses" :key="status" :value="status">{{ status }}</option>
                </select>
                <select v-model="filters.purpose" class="form-control" @change="fetchQuotations">
                  <option value="">All Purpose</option>
                  <option v-for="purpose in purposes" :key="purpose" :value="purpose">{{ purpose }}</option>
                </select>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>Quotation No</th>
                    <th>Date</th>
                    <th>Valid Until</th>
                    <th>Customer</th>
                    <th>Purpose</th>
                    <th>Status</th>
                    <th class="text-end">Items</th>
                    <th class="text-end">Grand Total</th>
                    <th class="text-end">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loading">
                    <td colspan="9" class="text-center py-4">Loading quotations...</td>
                  </tr>
                  <tr v-else-if="!quotations.length">
                    <td colspan="9" class="text-center py-4">No quotations found</td>
                  </tr>
                  <tr v-for="quotation in quotations" :key="quotation.quotationid">
                    <td>{{ quotation.quotationno }}</td>
                    <td>{{ formatDate(quotation.quotationdate) }}</td>
                    <td>{{ formatDate(quotation.validuntil) }}</td>
                    <td>
                      <strong>{{ quotation.customername }}</strong>
                      <span v-if="quotation.mobile" class="d-block text-muted">{{ quotation.mobile }}</span>
                    </td>
                    <td>{{ quotation.purpose }}</td>
                    <td>
                      <span class="badges" :class="statusClass(quotation.status)">{{ quotation.status }}</span>
                    </td>
                    <td class="text-end">{{ quotation.itemcount }}</td>
                    <td class="text-end">{{ money(quotation.netamount) }}</td>
                    <td class="text-end">
                      <button class="btn btn-sm btn-light me-1" title="Preview Quotation" @click="previewQuotation(quotation)">
                        <i class="fa fa-print"></i>
                      </button>
                      <router-link
                        v-if="quotation.status === 'DRAFT'"
                        class="btn btn-sm btn-light me-1"
                        :to="{ name: 'editquotation', query: { id: quotation.quotationid } }"
                        title="Edit"
                      >
                        <i class="fa fa-edit"></i>
                      </router-link>
                      <button
                        v-if="quotation.status === 'DRAFT'"
                        class="btn btn-sm btn-outline-primary me-1"
                        @click="changeStatus(quotation, 'SENT')"
                      >
                        Send
                      </button>
                      <button
                        v-if="quotation.status === 'SENT'"
                        class="btn btn-sm btn-outline-success me-1"
                        @click="changeStatus(quotation, 'ACCEPTED')"
                      >
                        Accept
                      </button>
                      <button
                        v-if="quotation.status === 'SENT'"
                        class="btn btn-sm btn-outline-danger me-1"
                        @click="changeStatus(quotation, 'REJECTED')"
                      >
                        Reject
                      </button>
                      <button
                        v-if="quotation.status === 'ACCEPTED'"
                        class="btn btn-sm btn-submit me-1"
                        @click="convertToSale(quotation)"
                      >
                        Convert
                      </button>
                      <button
                        v-if="quotation.status === 'DRAFT'"
                        class="btn btn-sm btn-light"
                        title="Delete"
                        @click="deleteQuotation(quotation)"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="quotation-pager">
              <span>Page {{ page }} of {{ totalPages || 1 }}</span>
              <div>
                <button class="btn btn-cancel me-2" :disabled="page <= 1" @click="movePage(-1)">Previous</button>
                <button class="btn btn-submit" :disabled="page >= totalPages" @click="movePage(1)">Next</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import { openPdfPreview } from "@/assets/utils/pdfPreview";
import { fetchQuotationPdf } from "@/services/invoicePdf";

export default {
  name: "quotationlist",
  data() {
    return {
      title: "Quotation List",
      title1: "Manage estimates before converting to sales",
      items: [{ text: "Add Quotation", addname: "/addquotation" }],
      loading: false,
      quotations: [],
      page: 1,
      pageSize: 10,
      totalPages: 0,
      filters: {
        search: "",
        status: "",
        purpose: "",
      },
      statuses: ["DRAFT", "SENT", "ACCEPTED", "REJECTED", "EXPIRED", "CONVERTED", "CANCELLED"],
      purposes: ["GENERAL", "LOAN", "INSURANCE", "TENDER", "OTHER"],
    };
  },
  mounted() {
    this.fetchQuotations();
  },
  methods: {
    async fetchQuotations() {
      this.loading = true;
      try {
        const { data } = await axios.get("/v1/quotations", {
          params: {
            page: this.page,
            page_size: this.pageSize,
            search: this.filters.search || undefined,
            status: this.filters.status || undefined,
            purpose: this.filters.purpose || undefined,
          },
        });
        this.quotations = data.items || [];
        this.totalPages = data.total_pages || 0;
      } catch (error) {
        this.showError(error, "Failed to load quotations");
      } finally {
        this.loading = false;
      }
    },
    async changeStatus(quotation, status) {
      try {
        await axios.patch(`/v1/quotations/${quotation.quotationid}/status`, { status });
        await Swal.fire({ icon: "success", title: "Updated", text: `Quotation marked as ${status}.`, timer: 1400, showConfirmButton: false });
        await this.fetchQuotations();
      } catch (error) {
        this.showError(error, "Failed to update quotation status");
      }
    },
    async convertToSale(quotation) {
      const result = await Swal.fire({
        icon: "question",
        title: "Convert to Sale?",
        text: "This will create a real sale and apply stock/ledger effects.",
        showCancelButton: true,
        confirmButtonColor: "#FF9F43",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, convert",
      });
      if (!result.isConfirmed) return;
      try {
        const { data } = await axios.post(`/v1/quotations/${quotation.quotationid}/convert`);
        await Swal.fire({ icon: "success", title: "Sale Created", text: `Sale ID: ${data.saleid}` });
        await this.fetchQuotations();
      } catch (error) {
        this.showError(error, "Failed to convert quotation");
      }
    },
    async deleteQuotation(quotation) {
      const result = await Swal.fire({
        icon: "warning",
        title: "Delete draft quotation?",
        text: "This action cannot be undone.",
        showCancelButton: true,
        confirmButtonColor: "#FF9F43",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete",
      });
      if (!result.isConfirmed) return;
      try {
        await axios.delete(`/v1/quotations/${quotation.quotationid}`);
        await Swal.fire({ icon: "success", title: "Deleted", timer: 1400, showConfirmButton: false });
        await this.fetchQuotations();
      } catch (error) {
        this.showError(error, "Failed to delete quotation");
      }
    },
    // The quotation PDF is generated by the server, in the same layout as the sales invoice.
    async previewQuotation(quotation) {
      if (!quotation?.quotationid) return;
      Swal.fire({ title: "Preparing quotation...", allowOutsideClick: false, didOpen: () => Swal.showLoading() });
      try {
        const { blob, fileName } = await fetchQuotationPdf(quotation.quotationid);
        Swal.close();
        openPdfPreview(blob, { title: `Quotation ${quotation.quotationno || ""}`.trim(), fileName });
      } catch (error) {
        console.error(error);
        this.showError(error, "Could not load the quotation PDF.");
      }
    },
    showError(error, fallback) {
      Swal.fire({
        icon: "error",
        title: "Quotation Error",
        text: error?.response?.data?.detail || fallback,
      });
    },
    movePage(step) {
      this.page += step;
      this.fetchQuotations();
    },
    formatDate(value) {
      if (!value) return "-";
      return new Date(value).toLocaleDateString("en-IN");
    },
    money(value) {
      return Number(value || 0).toFixed(2);
    },
    statusClass(status) {
      if (status === "ACCEPTED" || status === "CONVERTED") return "bg-lightgreen";
      if (status === "REJECTED" || status === "CANCELLED" || status === "EXPIRED") return "bg-lightred";
      if (status === "SENT") return "bg-lightyellow";
      return "bg-lightgrey";
    },
  },
};
</script>

<style scoped>
.quotation-filters {
  display: flex;
  gap: 10px;
}
.quotation-filters .form-control {
  min-width: 150px;
}
.quotation-pager {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding-top: 16px;
}
.badges {
  min-width: 82px;
  text-align: center;
}
</style>
